import { render, staticRenderFns } from "./moduleBgBlue.vue?vue&type=template&id=0b1def60&scoped=true"
import script from "./moduleBgBlue.vue?vue&type=script&lang=js"
export * from "./moduleBgBlue.vue?vue&type=script&lang=js"
import style0 from "./moduleBgBlue.vue?vue&type=style&index=0&id=0b1def60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1def60",
  null
  
)

export default component.exports